import { type Context, context, type Span, trace } from '@opentelemetry/api';
import { apiGet } from '@/api/apiClient';
import type { EntityFile } from '@/api/entities/types';
import { API_BASE } from '@/env';
import { instrumentAsync } from '@/otel';

export async function getEntityFiles(
  entityId: string,
  ctx?: Context,
): Promise<EntityFile[]> {
  return instrumentAsync(
    'api.entities.getEntityFiles',
    async (span: Span) => {
      const response = await apiGet<EntityFile[]>(
        `${API_BASE}/files?entityId=${entityId}`,
        trace.setSpan(context.active(), span),
      );

      return response.data;
    },
    ctx,
  );
}
